import * as React from "react";
import { FirmInstruction } from "../../../../../../../Wrap/Models/Models/Company/FirmInstruction";
import { SectionHeader } from "../../../../../../Dashboard/Components/Clients/NewBusinessWizard/Components/SharedComponents";
import { Typography } from "../../../../../../Shared/Typography/Typography";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";

interface IDefaultSettingProps extends IProcessComponentProps {
    data: FirmInstruction;
}

interface IDefaultSettingState {}

export class DefaultSetting extends ProcessComponent<IDefaultSettingProps, IDefaultSettingState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render() {
        const { AcornCommissionSettings } = this.props.data;
        return (
            <>
                {SectionHeader("Default Remuneration Settings")}
                <Typography
                    type="vertical"
                    config={[
                        { title: "Frequency", data: "Weekly" },
                        {
                            title: "Next payment date",
                            data: JsonDateParser.getFormatDateString(new Date(), "dd-MM-yyyy", true, true),
                        },
                        {
                            title: "Generate Online Statement",
                            data: "Yes",
                        },
                        {
                            title: "Generate EDI File",
                            data: "No",
                        },
                    ]}
                />
            </>
        );
    }
}
